export const AuthorType = {
  AUTHOR_TYPE_UNSPECIFIED: 1,
  REGULAR_USER: 2,
  LOCAL_GUIDE: 3,
  MERCHANT: 4
};
